import { Box, HStack, Stat, StatLabel, StatNumber, Text, Skeleton } from "@chakra-ui/react";
import IconTile from "./IconTile";
import CurrencyText from "./CurrencyText";

export default function StatCard({ label, value, icon, tone = "neutral", footnote, isLoading, ...rest }) {
  return (
    <Box p={4} {...rest}>
      <HStack spacing={3} align="flex-start">
        {icon ? <IconTile icon={icon} tone={tone} /> : null}
        <Stat>
          <StatLabel color="app-muted-fg" fontSize="sm">
            {label}
          </StatLabel>
          {isLoading ? (
            <Skeleton height="28px" width="100px" mt={1} />
          ) : (
            <StatNumber fontSize="2xl" fontWeight="bold">
              <CurrencyText value={value} />
            </StatNumber>
          )}
          {footnote ? (
            <Text fontSize="xs" color="app-muted-fg" mt={1}>
              {footnote}
            </Text>
          ) : null}
        </Stat>
      </HStack>
    </Box>
  );
}
